import { DeclarationService } from '../../services';
import { EmployeesService } from "../../services/index";
import * as moment from 'moment';
import * as signalR from '@aspnet/signalr/dist/browser/signalr.min.js';
import env from '../../config';
import { NotificationItemModel } from '../shared/notificationItem.model';
import { EnumService } from '../../services/enum.service';

class TimesheetsOverviewController implements ng.IComponentController {
    inprogress: boolean;
    currentNotification: any;
    progresscounter: { currentValue: any; totalValue: any; percentage: number; };
    _hubConnection: any;

    private sortType: string;
    private moment: any;
    private months: any = [];
    private currentMonth: any;
    private employees: any[];
    private summary: any;
    // _hubConnection: HubConnection;
    notifications: NotificationItemModel[] = [];
    progressNotifications: NotificationItemModel[] = [];

    constructor(private EmployeesService: EmployeesService,
        private $stateParams: ng.ui.IStateParamsService,
        private DeclarationService: DeclarationService,
        private EnumService: EnumService,
        private $scope: ng.IScope
    ) {
        'ngInject';
    }

    $onInit = () => {
        this.sortType = 'account.name';
        this.moment = require('moment');

        if (this.moment().subtract(1, 'year').format('YYYY') < 2020) {
            for (var i = 11; i <= 13; i++) {
                this.months.push({
                    index: i,
                    startDate: this.moment().subtract(1, 'year').startOf('year').add((i - 1) * 4, 'weeks').startOf('isoweek').toDate(),
                    endDate: this.moment().subtract(1, 'year').startOf('year').add((i - 1) * 4 + 3, 'weeks').endOf('isoweek').toDate(),
                    year: this.moment().subtract(1, 'year').format('YYYY'),
                    month: i
                });
            }
            this.months.find(m => m.month == 13 && m.year == 2019).endDate = this.moment('2019-12-02').endOf('month').toDate();
        } else {
            for (var i = 9; i <= 11; i++) {
                this.months.push({
                    index: i,
                    startDate: this.moment().subtract(1, 'year').startOf('year').add(i, 'months').toDate(),
                    endDate: this.moment().subtract(1, 'year').startOf('year').add(i, 'months').endOf('month').toDate(),
                    year: this.moment().subtract(1, 'year').format('YYYY'),
                    month: this.moment().subtract(1, 'year').startOf('year').add(i, 'months').format('M')
                });
            }
        }

        if (this.moment().format('YYYY') < 2020) {
            for (var i = 1; i <= 13; i++) {
                this.months.push({
                    index: i,
                    startDate: this.moment().startOf('year').add((i - 1) * 4, 'weeks').startOf('isoweek').toDate(),
                    endDate: this.moment().startOf('year').add((i - 1) * 4 + 3, 'weeks').endOf('isoweek').toDate(),
                    year: this.moment().format('YYYY'),
                    month: i
                });
            }
            this.months.find(m => m.month == 13 && m.year == 2019).endDate = this.moment('2019-12-02').endOf('month').toDate();
        } else {

            for (var i = 0; i <= 11; i++) {
                this.months.push({
                    index: i,
                    startDate: this.moment().startOf('year').add(i, 'months').toDate(),
                    endDate: this.moment().startOf('year').add(i, 'months').endOf('month').toDate(),
                    year: this.moment().format('YYYY'),
                    month: this.moment().startOf('year').add(i, 'months').format('M')
                });
            }
        }

        this.currentMonth = this.months.find(m => m.month == this.moment().format('M') && m.year == this.moment().format('YYYY'))

        this.initHubConnection();
    }

    initHubConnection() {
        // console.log('initHubConnection');
        this._hubConnection = new signalR.HubConnectionBuilder()
            .withUrl(env.BASE_URL + 'notification')
            .build();
        //this._hubConnection = new HubConnection(env.BASE_URL + 'notification');
        this._hubConnection.on('Notify', (notificationItem: NotificationItemModel) => {
            // console.log('event');
            // console.log(notificationItem);
            this.notify(notificationItem);

        });
        // console.log('Hello ._hubConnection.start');
        this._hubConnection.start()
            .then(() => {
                // console.log('Hub connection started');
            })
            .catch((reason) => {
                // console.log('Error while establishing connection');
                // console.log(reason);
            });
    }

    notify(notificationItem) {
        switch (notificationItem.notificationType) {
            case 1:
                //Start
                this.$scope.$apply(() => {
                    this.currentNotification = notificationItem;
                    this.inprogress = true;
                    this.notifications.push(notificationItem);
                });
                break;
            case 2:
                //Progress
                this.inprogress = true;
                var percentage = (notificationItem.currentValue / notificationItem.totalValue) * 100;
                this.progresscounter = { currentValue: notificationItem.currentValue, totalValue: notificationItem.totalValue, percentage: percentage };
                this.currentNotification = notificationItem;
                this.$scope.$apply(() => {
                    this.progressNotifications.push(notificationItem);
                });
                break;
            case 3:
                //Information
                this.$scope.$apply(() => {
                    this.currentNotification = notificationItem;
                    this.notifications.push(notificationItem);
                });
                break;
            case 4:
                //Finish
                this.$scope.$apply(() => {
                    this.currentNotification = notificationItem;
                    this.notifications.push(notificationItem);
                    this.inprogress = false;
                });
                break;
        }
    }

    getTimesheets() {
        var start = moment(this.currentMonth.startDate).format('YYYY-MM-DD');
        var end = moment(this.currentMonth.endDate).format('YYYY-MM-DD');
        this.EmployeesService.customAll('employeeSummary', { from: start, till: end }).then((result: Restangular.ICollection) => {
            this.employees = result;
            this.getCompletionData();
        });
    }

    getCompletionData() {
        // console.log('getCompletionData')
        this.summary = {};
        this.summary.scheduledHours = 0;
        this.summary.scheduledShiftsCount = 0;
        this.summary.declaredHours = 0;
        this.summary.declaredShiftsCount = 0;
        this.summary.approvedHours = 0;
        this.summary.approvedShiftsCount = 0;

        this.employees.forEach(e => {
            e.approvedShiftCount = 0;
            e.approvedShiftHours = 0;
            e.declarationsApproved = true;

            e.doneShiftCount = e.shifts.filter(s => s.declarations.length > 0).length;

            e.shifts.forEach(s => {
                if (s.declarations.length > 0) {
                    this.summary.declaredShiftsCount++;
                    if (s.declarations.filter(d => d.status != 3).length == 0) {
                        e.approvedShiftCount++;
                    }
                }

                s.declarations.forEach(d => {
                    this.summary.declaredHours += d.duration;
                    if (d.status == 3) {
                        e.approvedShiftHours += d.duration;
                    } else {
                        e.declarationsApproved = false;
                    }
                });
            });

            this.summary.scheduledHours += e.shiftHours;
            this.summary.scheduledShiftsCount += e.shiftCount;
            this.summary.approvedHours += e.approvedShiftHours;
            this.summary.approvedShiftsCount += e.approvedShiftCount;
        });

        this.summary.scheduledHours = this.summary.scheduledHours.toFixed(2);
        this.summary.scheduledShiftsCount = this.summary.scheduledShiftsCount.toFixed(2);
        this.summary.declaredHours = this.summary.declaredHours.toFixed(2);
        this.summary.declaredShiftsCount = this.summary.declaredShiftsCount.toFixed(2);
        this.summary.approvedHours = this.summary.approvedHours.toFixed(2);
        this.summary.approvedShiftsCount = this.summary.approvedShiftsCount.toFixed(2);
    }

    sendToNmbrs() {
        var start = moment(this.currentMonth.startDate).format('YYYY-MM-DD');
        var end = moment(this.currentMonth.endDate).format('YYYY-MM-DD');

        // lil hack here, so they bill the last period in 2019 correctly
        if (start == '2019-01-01')
            start = '2019-01-02';

        (<any>$('#notificationModal')).modal({ backdrop: 'static', keyboard: false });

        if (!this.inprogress) {
            this.DeclarationService.customGet('pushtonmbrs', { from: start, till: end }).then(() => {
                (<any>$('#notificationModal')).modal('show');
            });
        } else {
            (<any>$('#notificationModal')).modal('show');
        }
    }
}

export const timesheetsOverviewComponent: ng.IComponentOptions = {
    controller: TimesheetsOverviewController,
    template: require('./timesheetsOverview.html')
};


// WEBPACK FOOTER //
// ./src/app/modules/timesheets/timesheetsOverview.component.ts